export default "__VITE_ASSET__39e2b2f8__"